import { render, staticRenderFns } from "./SplashPage.vue?vue&type=template&id=d77e4298"
import script from "./SplashPage.vue?vue&type=script&lang=js"
export * from "./SplashPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports